import { apiProxyRequest } from "Api/apiProxyRequest";
import { encodeParameters } from "Api/utils";

import type { DeploymentLocalDedicated } from "./types";

export const getDeploymentLocalDedicatedRequest = ({
  projectId
}: {
  projectId: string;
}) => {
  const { projectId: encodedProjectId } = encodeParameters({ projectId });

  return apiProxyRequest<DeploymentLocalDedicated>(
    `/projects/${encodedProjectId}/deployments/local-dedicated`
  );
};
